import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LoginModalState {
  isOpen: boolean;
  isLoggedIn: boolean;
  modalKey?: string;
}

const initialState: LoginModalState = {
  isOpen: false,
  isLoggedIn: false, // Real value is preloaded from server cookies in makeStore
  modalKey: undefined,
};

const loginModalSlice = createSlice({
  name: "loginModal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<string | undefined>) => {
      state.isOpen = true;
      state.modalKey = action.payload; // store key when opening
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.modalKey = undefined; // clear key on close
    },
    setLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
    setModalKey: (state, action: PayloadAction<string | undefined>) => {
      state.modalKey = action.payload;
    },
  },
});

export const { openModal, closeModal, setLoggedIn, setModalKey } = loginModalSlice.actions;
export default loginModalSlice.reducer;
